<template>
  <div class="delete-appointments-root">
    <h1 class="header-text mb-3">
      <span
        >Brisanje termina
        <div class="header-text-line"></div>
      </span>
    </h1>
    <div class="input">
      <v-menu
        ref="dateFromMenu"
        :close-on-content-click="true"
        v-model="dateFromMenu"
        :nudge-right="40"
        :return-value.sync="dateFromModel"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          v-model="dateFromModel"
          label="Odaberite datum od"
          prepend-icon="event"
          readonly
        ></v-text-field>

        <v-date-picker
          v-model="dateFromModel"
          @input="$refs.dateFromMenu.save(dateFromModel)"
          no-title
          scrollable
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="input">
      <v-menu
        ref="dateToMenu"
        :close-on-content-click="true"
        v-model="dateToMenu"
        :nudge-right="40"
        :return-value.sync="dateToModel"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          v-model="dateToModel"
          label="Odaberite datum do"
          prepend-icon="event"
          readonly
        ></v-text-field>

        <v-date-picker
          v-model="dateToModel"
          @input="$refs.dateToMenu.save(dateToModel)"
          no-title
          scrollable
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="input">
      <v-select
        label="Odaberite dan"
        v-model="selectedDay"
        :items="daysOfTheWeek"
        item-text="name"
        item-value="value"
      ></v-select>
    </div>
    <div class="input">
      <v-select
        label="Odaberite studio"
        v-model="selectedStudio"
        :items="studioList"
        item-text="Name"
        item-value="StudioId"
      ></v-select>
    </div>
    <div class="d-flex mt-1">
      <div class="input">
        <p>Vrijeme od:</p>
        <vue-timepicker
          class="time-picker"
          v-model="timeFrom"
          :minute-interval="5"
        ></vue-timepicker>
      </div>
      <div class="input">
        <p>Vrijeme do:</p>
        <vue-timepicker
          class="time-picker"
          v-model="timeTo"
          :minute-interval="5"
        ></vue-timepicker>
      </div>
    </div>

    <div class="actions mt-5">
      <v-btn
        v-if="!deleteBtnClicked"
        class="v-btn warning"
        :disabled="deleteBtnDisabled"
        @click="onDeleteButtonClicked"
        >Obrisi termine</v-btn
      >
      <v-btn
        v-if="deleteBtnClicked"
        class="v-btn warning"
        :disabled="deleteBtnDisabled"
        @click="onDeleteAppointments"
        >Potvrdite brisanje termina</v-btn
      >
    </div>
  </div>
</template>
<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  components: { VueTimepicker },
  data() {
    return {
      // Modals
      dateFromMenu: false,
      dateToMenu: false,

      //Helpers
      deleteBtnClicked: false,

      //Data
      dateFromModel: null,
      dateToModel: null,
      timeFrom: null,
      timeTo: null,
      selectedDay: null,
      selectedStudio: null,

      //Dropdowns
      studioList: [], // fetched from service
      daysOfTheWeek: [
        { name: "Ponedjeljak", value: 1 },
        { name: "Utorak", value: 2 },
        { name: "Srijeda", value: 3 },
        { name: "Cetvrtak", value: 4 },
        { name: "Petak", value: 5 },
        { name: "Subota", value: 6 },
        { name: "Nedjelja", value: 7 },
      ],
    };
  },
  computed: {
    deleteBtnDisabled() {
      if (
        !this.dateFromModel ||
        !this.dateToModel ||
        !this.timeFrom ||
        !this.timeTo ||
        !this.selectedDay ||
        !this.selectedStudio
      ) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.getStudioList();
  },
  methods: {
    onDeleteAppointments() {
      this.deleteBtnClicked = false;
      let postObject = {
        userId: localStorage.getItem("user"),
        dateFrom: this.dateFromModel,
        dateTo: this.dateToModel,
        timeFrom: "",
        timeTo: "",
        dayOfTheWeekIndex: this.selectedDay,
        studioId: this.selectedStudio,
      };

      var tf = this.timeFrom;
      var tt = this.timeTo;
      postObject.TimeFrom = tf.HH + ":" + tf.mm;
      postObject.TimeTo = tt.HH + ":" + tt.mm;

      this.$store.state.services.appointmentService
        .deleteAppointments(postObject)
        .then((response) => {})
        .catch((err) => {})
        .finally(() => {});
    },
    getStudioList() {
      this.$store.state.services.studioService
        .getForDropdown()
        .then((response) => {
          this.studioList = response.data;
        });
    },
    onDeleteButtonClicked() {
      this.deleteBtnClicked = true;
    },
  },
};
</script>
<style scoped>
.delete-appointments-root {
  background: #fff;
  padding: 20px;
}
.delete-appointments-root .input {
  width: 100%;
}
.actions {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
</style>
